import axios from "../../../config/axiosConfig";

export const buscarVehiculoGlobal = async (valor, valorExtra) => {
  try {
    const response = await axios.get("/api/vehiculos/buscar-global", {
      params: { valor, valorExtra },
    });
    return response.data;
  } catch (error) {
    console.error("Error al buscar vehículo:", error);
    throw error;
  }
};

export const compararListaPlacas = async (placas) => {
  try {
    const response = await axios.post("/api/vehiculos/comparar-lista", { placas });
    return response.data;
  } catch (error) {
    console.error("Error al comparar lista de placas:", error);
    throw error;
  }
};
// Duplica en Leasecontrol una unidad de Wialon (solo alta en la plataforma, sin tocar
// módem/chip locales). Si no hay tipo de dispositivo equivalente responde 422 con
// requiereHwType y hay que reintentar con hwTypeId.
export const copiarUnidadWialonALeasecontrol = (wialonUnitId, hwTypeId) =>
  axios.post("/api/leasecontrol/unidades/copiar-desde-wialon", { wialonUnitId, hwTypeId });
